import React from 'react';
import { Paper, Button } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { alpha } from '@mui/material/styles';

const NavigationButton = ({ onNext }) => {
  return (
    <Paper 
      sx={{ 
        mt: 2,
        p: 2,
        display: 'flex',
        justifyContent: 'flex-end',
        bgcolor: theme => alpha(theme.palette.primary.main, 0.03)
      }}
    >
      <Button
        variant="contained"
        color="primary"
        onClick={onNext}
        endIcon={<NavigateNextIcon />}
        sx={{
          px: 4,
          py: 1.5,
          borderRadius: 2,
          boxShadow: 3
        }}
      >
        Kaydet ve İlerle
      </Button>
    </Paper>
  );
};

export default NavigationButton;
